var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InfoCircleSVG',{staticClass:"fill-white-3",class:_vm.sizeClasses})
}
var staticRenderFns = []

export { render, staticRenderFns }